import { useSelector } from "react-redux";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { selectLevelRankingRiders } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice";
import { selectUniformCoverageRiders } from "../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice";
import { selectSalaryRankRiders } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice";
import { selectAmountOfLoansRiders } from "../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice";
import { isInvalidRiderAmount } from "../../utils/is-invalid-rider-amount.utils";
import { getAmountValidationMessage } from "../../utils/get-amount-validation-message.utils";
import { SalaryRankRider } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.state";
import { LevelRankingRider } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.state";
import { selectedRidersState } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { useToastify } from "../../library/toastify/toast-provider";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";

export const useInputsRidersValidation = () => {

    const { showToastNotify } = useToastify();
    const selectedRiders = useSelector(selectedRidersState);
    const selectLevelRankingRidersState = useSelector(selectLevelRankingRiders);
    const selectUniformCoverageRidersState = useSelector(selectUniformCoverageRiders);
    const selectSalaryRankRidersState = useSelector(selectSalaryRankRiders);
    const selectAmountOfLoansRidersState = useSelector(selectAmountOfLoansRiders);
    const { isLevelRanking, isUniformCoverage, isSalaryRank, isProductGCLI } = useProposalTypeData();
    const isAmountOfLoans = isProductGCLI

    const isValidSelectedRiders = (): boolean => {
        if (!selectedRiders?.length) return true;

        if (isLevelRanking) {
            const invalidGDR = selectLevelRankingRidersState?.find((rider: LevelRankingRider) =>
                Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => Number(id) === Number(rider.id)) &&
                !rider.inputs.some((input) => Number(input.fAmount) > 0)
            );

            if (invalidGDR) {
                showToastNotify(`${invalidGDR.label} must select at least one.`, "warning");
                return false;
            }

            const invalidRider = selectLevelRankingRidersState?.find((rider: LevelRankingRider) =>
                rider.inputs.some((input) => 
                    isInvalidRiderAmount(rider.id, Number(input.fAmount))
                )
            );

            const invalidInput = invalidRider?.inputs.find((input) => 
                isInvalidRiderAmount(invalidRider.id, Number(input.fAmount))
            );

            if (invalidRider && invalidInput) {
                const errorMessage = getAmountValidationMessage(invalidRider.id, invalidRider.label, invalidInput.label)
                showToastNotify(errorMessage, "warning" )
                return false;
            }
            return true;
        }

        if (isUniformCoverage) {
            const invalidGDR = selectUniformCoverageRidersState?.find((item) =>
                    Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => Number(id) === Number(item.id)) &&
                    Number(item.rider.fAmount) <= 0
            );

            if (invalidGDR) {
                showToastNotify(`${invalidGDR.label} must select at least one.`, "warning");
                return false;
            }

            const invalidRider = selectUniformCoverageRidersState?.find((item) => {
                isInvalidRiderAmount(item.id, Number(item.rider.fAmount))
            });

            if (invalidRider) {
                const errorMessage = getAmountValidationMessage(invalidRider.id, invalidRider.label, invalidRider.rider.label)
                showToastNotify(errorMessage, "warning" )
                return false;
            }

            return true;
        }

        if (isSalaryRank) {
            const invalidGDR = selectSalaryRankRidersState?.find((rider: SalaryRankRider) =>
                    Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => Number(id) === Number(rider.id)) &&
                    !rider.rider.some((input) => Number(input.result) > 0)
            );

            if (invalidGDR) {
                showToastNotify(`${invalidGDR.label} must select at least one.`, "warning");
                return false;
            }

            const invalidRider = selectSalaryRankRidersState?.find((rider: SalaryRankRider) =>
                rider.rider.some((input) => 
                    isInvalidRiderAmount(rider.id, Number(input.result))
                )
            );

            const invalidInput = invalidRider?.rider.find((input) => {

                isInvalidRiderAmount(invalidRider.id, Number(input.result))
            });

            if (invalidRider && invalidInput) {
                const errorMessage = getAmountValidationMessage(invalidRider.id, invalidRider.label, invalidInput.designation)
                showToastNotify(errorMessage, "warning" )
                return false;
            }

            return true;
        }

        if (isAmountOfLoans) {
            const invalidGDR = selectAmountOfLoansRidersState?.find((item) =>
                Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => Number(id) === Number(item.id)) &&
                Number(item.rider.fAmount) <= 0
            );

            if (invalidGDR) {
                showToastNotify(`${invalidGDR.label} must select at least one.`, "warning");
                return false;
            }

            const invalid = selectAmountOfLoansRidersState?.find((rider) =>
                isInvalidRiderAmount(rider.id, Number(rider.rider.fAmount))
            );

            if (invalid) {
                showToastNotify(`${invalid.label} must have an amount.`, "warning");
                return false;
            }

            return true;
        }

        return true;
    };

    return {
        isValidSelectedRiders
    }
}